import { useAppDispatch } from 'lib/centralStore';
import { NotifiesBoxCms } from 'lib/datoCms/queries/getNotifiesBox';
import { useEffect, useState } from 'react';
import { getNotifiesBox } from '../action';
import { useRef } from 'react';

export const useGetNotifiesBox = () => {
  const dispatch = useAppDispatch();
  const [notifiesBox, setNotifiesBox] = useState<Array<NotifiesBoxCms> | null>(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      const fetchNotifies = async () => {
        const notifies = await dispatch(getNotifiesBox()).unwrap();
        if (notifies) {
          setNotifiesBox(notifies);
        }
        hasFetchedRef.current = true;
      };

      fetchNotifies();
    }
  }, [dispatch]);

  return notifiesBox;
};
